export const COLORS = {
  LIGHT_BLUE: '#022E8D',
  BLUE: '#022673',
  DARK_BLUE: '#01143e',
  GREEN: '#00c36b',
  RED: '#ff4a4a',
  DARK_RED: '#cf2b2b',
  GRAY_1: '#f2f2f2',
  GRAY_2: '#e6e6e6',
  GRAY_3: '#989898',
  GRAY_4: '#696969',
};
